import { Box, styled } from '@mui/material';

const ErrorBox = styled(Box)`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const LoadingBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 30px;
`;

const LoginBox = styled(Box)`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export { ErrorBox, LoadingBox, LoginBox };
